var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMemory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#001838"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#64B3E1",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0001 16.3335H29.6667L19.6667 26.3335V46.3335C19.6667 48.1668 21.1667 49.6668 23.0001 49.6668H43.0001C44.8334 49.6668 46.3334 48.1668 46.3334 46.3335V19.6668C46.3334 17.8335 44.8334 16.3335 43.0001 16.3335ZM43.0001 46.3335H23.0001V27.7168L31.0501 19.6668H43.0001V46.3335ZM28.0001 24.6668H31.3334V31.3335H28.0001V24.6668ZM33.0001 24.6668H36.3334V31.3335H33.0001V24.6668ZM38.0001 24.6668H41.3334V31.3335H38.0001V24.6668Z",
    fill: "#ECF6FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMemory);
export default __webpack_public_path__ + "static/media/home-memory.327586b6c72115e3aea7fa629d276101.svg";
export { ForwardRef as ReactComponent };